import { lazy } from "react";
export { TEST_PARTICIPANT_RESULT_PATH } from "./path";
export { ToTestParticipantResult } from "./to-test-participant-result";
export const TestParticipantResultPage = lazy(() => import("./page"));
